<template>
  <div class="home">
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <div class="wrapper-content">
      <div class="addmoney newaddress registerPageContent">
        <div class="container">
          <div class="row">
            <div class="offset-sm-3 col-sm-6">
              <b-form class="add-newaddresss register-phn" @submit.prevent="getOtp">
                <div class="phone-register">
                  <p class="text-left">{{ $t('message.EnterNumber') }}</p>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">+{{countryCode}}</span>
                    </div>

                    <b-form-input
                      v-model="phoneNumber"
                      :maxlength="phoneNumberlength"
                      :placeholder="$t('message.PhoneNumber') "
                    ></b-form-input>
                  </div>
                  <div
                    class="error"
                    v-if="!phoneNumber && isError"
                  >{{ $t('message.EnterPhoneNumber') }}</div>
                  <div class="error" v-if="!$v.phoneNumber.num">{{ $t('message.onlyNumbers') }}</div>
                  <div
                    class="error"
                    v-if="lengthErr"
                  >{{ $t('message.PhoneLengthErr') }} {{ phoneNumberlength }} {{$t('message.digits')}}</div>
                </div>
                <div class="bottom-moreinfo">
                  <p>{{ $t('message.RegisterText') }}</p>
                </div>
                <button class="submit-btn">{{ $t('message.Submit') }}</button>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { VueTelInput } from "vue-tel-input";
import {
  sendOtp,
  getDomainbaseVendorInfo,
  getmasterConfiguration
} from "./../services/api";
import VueGeolocation from "vue-browser-geolocation";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Vuelidate from "vuelidate";
import { required, helpers } from "vuelidate/lib/validators";
Vue.use(Vuelidate);
const axios = require("axios");
Vue.use(VueGeolocation);

const num = helpers.regex("num", /^(0|[1-9][0-9]*)$/);
export default {
  name: "home",
  components: {
    VueTelInput,
    Loading
  },

  data() {
    return {
      isLoading: false,
      fullPage: true,
      isError: false,
      lat: "",
      long: "",
      phoneNumber: "",
      logoImg: "",
      imageBaseUrl: "https://trakop.s3.amazonaws.com/",
      phoneNumberlength: "",
      countryCode: "",
      lengthErr: false
    };
  },
  validations: {
    phoneNumber: {
      required,
      num
    }
  },

  mounted() {
    setTimeout(
      () => (
        (this.countryCode = localStorage.getItem("countryCode")),
        (this.phoneNumberlength = localStorage.getItem("numberLength"))
      ),
      1000
    );
  },

  methods: {
    skipLogin() {
      localStorage.setItem("isSkip", true);
      this.$router.push("/home");
    },
    getOtp() {
      if (!this.$v.$invalid) {
        this.isError = false;
        if (this.phoneNumber.length != this.phoneNumberlength) {
          this.lengthErr = true;
        } else {
          localStorage.setItem("phoneNumber", this.phoneNumber);
          this.lengthErr = false;
          // var requestData = {
          //   phone: this.phoneNumber,
          //   otp_type: "send",
          //   vendor_id: localStorage.getItem("vendorId"),
          //   user_type: "customer"
          // };
          // this.isLoading = true;
          // sendOtp(requestData)
          //   .then(result => {
          //     console.log("aaaaaaaaa", result);
          //     if (result.data.successCode === 200) {
          //       localStorage.setItem("isSkip", false);
          this.$router.push("/enter-otp");
          //     this.isLoading = false;
          //   }
          // })
          // .catch(error => {
          //   this.isLoading = false;

          //   return;
          // });
        }
      } else {
        this.isError = true;
      }
    },
    getVendorDetails() {
      var requestData = {
        domain: window.location.host
      };

      getDomainbaseVendorInfo(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            this.logoImg = this.imageBaseUrl + result.data.data.logo;
            localStorage.setItem("vendorId", result.data.data.vendor_id);
            localStorage.setItem("metaTag", result.data.data.header_script);
            localStorage.setItem("websiteName", result.data.data.website_title);
            localStorage.setItem("logoImg", result.data.data.logo);
            localStorage.setItem("headerColor", result.data.data.layout_color);
          }
        })
        .catch(error => {
          return;
        });
    }
  }
};
</script>
<style lang="scss">
@import "../assets/css/custom.scss";
</style>